var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 26.2979C0 11.774 11.774 0 26.2979 0C40.8218 0 52.5957 11.774 52.5957 26.2979C52.5957 40.8218 40.8218 52.5957 26.2979 52.5957C11.774 52.5957 0 40.8218 0 26.2979Z",
    fill: "#C6A75E",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6808 36.1596V33.9681C30.6808 32.8056 30.219 31.6908 29.397 30.8688C28.575 30.0469 27.4602 29.5851 26.2978 29.5851H19.7233C18.5609 29.5851 17.446 30.0469 16.6241 30.8688C15.8021 31.6908 15.3403 32.8056 15.3403 33.9681V36.1596",
    stroke: "#C6A75E",
    strokeWidth: 2.19149,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0104 25.2021C25.4311 25.2021 27.3934 23.2398 27.3934 20.8191C27.3934 18.3985 25.4311 16.4362 23.0104 16.4362C20.5898 16.4362 18.6274 18.3985 18.6274 20.8191C18.6274 23.2398 20.5898 25.2021 23.0104 25.2021Z",
    stroke: "#C6A75E",
    strokeWidth: 2.19149,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2555 36.1596V33.9681C37.2548 32.9969 36.9315 32.0536 36.3366 31.286C35.7416 30.5185 34.9086 29.9703 33.9683 29.7275",
    stroke: "#C6A75E",
    strokeWidth: 2.19149,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6807 16.5786C31.6235 16.82 32.4591 17.3683 33.0558 18.1371C33.6526 18.9059 33.9765 19.8514 33.9765 20.8246C33.9765 21.7978 33.6526 22.7434 33.0558 23.5121C32.4591 24.2809 31.6235 24.8292 30.6807 25.0706",
    stroke: "#C6A75E",
    strokeWidth: 2.19149,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon 2.92fd15f8a70e1a9d7084c0fe86160ec2.svg";
export { ForwardRef as ReactComponent };